export const shadows = {
  xs: {
    elevation: 1,
    shadowColor: '#000',
    shadowRadius: 1,
    shadowOffset: { height: 1, width: 0 },
    shadowOpacity: 0.075,
  },
  sm: {
    elevation: 4,
    shadowColor: '#000',
    shadowRadius: 3,
    shadowOffset: { height: 3, width: 0 },
    shadowOpacity: 0.15,
  },
  md: {
    elevation: 8,
    shadowColor: '#000',
    shadowRadius: 8,
    shadowOffset: { height: 6, width: 0 },
    shadowOpacity: 0.15,
  },
  lg: {
    elevation: 16,
    shadowColor: '#000',
    shadowRadius: 10,
    shadowOffset: { height: 10, width: 0 },
    shadowOpacity: 0.17,
  },
  xl: {
    elevation: 28,
    shadowColor: '#000',
    shadowRadius: 25,
    shadowOffset: { height: 16, width: 0 },
    shadowOpacity: 0.2,
  },
};
